<template>
  <div>
    <el-card class="box-card tablecard" shadow="never">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> Statistics of submitted projects by institution </span>
      </div>
      <div>
        <!-- <h3>{{htitle}} 下载排行</h3> -->
        <div class="mb10 textRight">
          Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        </div>
        <el-table
          v-loading="loading"
          @sort-change="handleSort"
          :data="sData"
          height="800"
          border
          stripe
          style="width: 100%">
          <el-table-column
            prop="institution"
            label="institution"
            :show-overflow-tooltip="isOverflow"
            sortable>
            <template slot-scope="scope">
              <span class="tablelink" @click="handleClickInst(scope.row.institution)">
                {{scope.row.institution}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="project_num"
            label="The number of projects"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="project_amount"
            label="Data size(GB)"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="percent"
            label="The percent of projects by institution"
            sortable>
            <template slot-scope="scope">
              <span>
                {{scope.row.percentstr}}%
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="allNum"
          :page-size="pageSize"
          @current-change="handleChangepage"
          class="pagination mb10">
        </el-pagination>
        <!-- <div id="myCharts" :style="{height: '400px','margin-top': '60px'}"></div> -->
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10" shadow="never" v-if="isShowpro">
      <div slot="header" class="clearfix textLeft">
        <span><i class="fa fa-gift fs14" /> Project Information List </span>
      </div>
      <div>
        <!-- <div class="mb10 textRight">
          Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
        </div> -->
        <el-table
          v-loading="loading2"
          @sort-change="handleSort2"
          :data="proData"
          height="800"
          border
          stripe
          style="width: 100%"
          :row-key="getRowKeys"
          :expand-row-keys="expands"
          @expand-change="handleExpand">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                border
                v-loading="subloading"
                :data="props.row.subtableData"
                style="width: 100%">
                <!-- <el-table-column
                  prop=""
                  label=" "
                  width="50">
                </el-table-column> -->
                <el-table-column
                  prop="subtitle_en"
                  label="Subproject Title"
                  width="210"
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  prop="subproject_id"
                  label="Subproject ID">
                </el-table-column>
                <el-table-column
                  prop="px_id"
                  label="PXID">
                </el-table-column>
                <el-table-column
                  prop="species"
                  label="Species">
                </el-table-column>
                <el-table-column
                  prop="instrument"
                  label="Instrument"
                  :show-overflow-tooltip="isOverflow">
                </el-table-column>
                <el-table-column
                  prop="fileCount"
                  label="File Count (size)">
                </el-table-column>
                <el-table-column
                  prop="submit_time"
                  label="Release Date">
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            prop="project_title_english"
            label="ProjectName"
            :show-overflow-tooltip="isOverflow"
            sortable>
          </el-table-column>
          <el-table-column
            prop="project_id"
            label="ProjectID"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="submission_type"
            label="SubmissionType"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="proteomexchange_id"
            label="PXID"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="pubmed_id"
            label="Publication"
            sortable>
            <template slot-scope="scope">
              <span>
                <a :href="publictionUrl+scope.row.pubmed_id">{{scope.row.pubmed_id}}</a>
                {{scope.row.reference}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="submitter"
            label="Submitter"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="lab_header"
            label="Labhead"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="institution_english"
            label="Institution"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="sub_count"
            label="SubprojectCount"
            sortable>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="isOverflow"
            prop="submit_time"
            label="Release date"
            sortable>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="allNum2"
          :page-size="pageSize2"
          @current-change="handleChangepage2"
          class="pagination mb10">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStatProjectByInstitution, getStatProjectListByInstitution, getSearchSubProjectList } from '@/api'
import echarts from 'echarts'
export default {
  name: 'statistics',
  data() {
    return {
      publictionUrl: 'http://www.ncbi.nlm.nih.gov/pubmed?term=',
      sData: [],
      loading: true,
      allNum: 0,
      pageSize: 20,
      searchkey: '',
      ajax_data: {
        search:{
          data_type: 'submitted',
          sub: ''
        },
        page:{
          startPage: 1,
          pageLength: 20
        },
        order:{
          item: '',
          type: ''
        }
      },
      ajax_data_pro: {
        search:{
          data_type: 'submitted',
          institution: ''
        },
        page:{
          startPage: 1,
          pageLength: 20
        },
        order:{
          item: '',
          type: ''
        }
      },
      isOverflow: true,
      isShowpro: false,
      proData: [],
      loading2: true,
      allNum2: 0,
      pageSize2: 20,
      orderConvert: {
        ascending: 'asc',
        descending: 'desc'
      },
      ajax_data_sublist: {
        search:{
          project_id: '',
          sub: ''
        },
        page:{
          startPage: 1,
          pageLength: 0
        },
        order:{
          item: '',
          type: ''
        }
      },
      subloading: false,
      expands: [],
      getRowKeys (row) {
        return row.project_id
      }
    }
  },
  mounted() {
    
  },
  created() {
    getStatProjectByInstitution(this.ajax_data).then(res => {
      this.loading = false
      this.allNum = res.count
      let newData = res.result
      newData.forEach((val, index) => {
        val.percentstr = (val.percent*100).toFixed(2)
      })
      this.sData = newData
      let dataArr = []
      newData.map(item => {
        let datastr = { 
          value: item.project_num, 
          name: item.institution 
        }
        dataArr.push(datastr)
      })
      console.log(dataArr)
      // this.option.series.data = dataArr
      let option = {
        // title: {
        //   text: 'Top 10 ',
        //   subtext: 'Total datasets: ',
        //   left: 'center'
        // },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: "{b}: {c}({d}%)"
        },
        legend: {
          type: 'scroll',
          top: '5%',
          bottom: '8%',
          bottom: 'center',
          orient: 'horizontal'
        },
        colorBy: 'data',
        // legend: {
        //   orient: 'vertical',
        //   left: 'left'
        // },
        series: [{
          // name: 'Access From',
          top: '30px',
          type: 'pie',
          radius: ['40%', '70%'],
          label: {
            formatter: "{b}: {c}",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 22,
              fontWeight: 'bold',
              formatter: '{b}: {c}'
            }
          },
          labelLine: {
            show: true
          },
          data: dataArr
          // itemStyle: {
          //   // 通常情况下：
          //   normal: {
          //     // 每个颜色即为colorList数组里的每一项，如果数目多于colorList的长度，则颜色循环使用该数组
          //     color: function (colors) {
          //       // console.log(typeof (orderArr[params.dataIndex]))
          //       // var colorList = ['#ffdd00', '#7f6a9c', '#6aa692', '#fbdad9', '#1280c4', '#d1cbe5', '#96c08e', '#f9a266', '#95d4f5', '#f8bdd7', '#a1a8aa', '#a7dacd', '#fccab3', '#de6c7d']
          //       var colorList = ['#1f77b4', '#afc8e8', '#ff7f0e', '#ffbb78', '#2ca02c', '#98df8a', '#d62728', '#ff9896', '#9467bd', '#0c9fb8', '#c5b0d5', '#a7dacd', '#fccab3', '#de6c7d']
          //       return colorList[colors.dataIndex]
          //     }
          //   }
          // }
        }]
      }
      // let charts = this.$echarts.init(document.getElementById('myCharts'))
      // charts.setOption(option)
    })
    this.ajax_data.page.pageLength = 0
    getStatProjectByInstitution(this.ajax_data).then(res => {
      let dataArr = []
      res.result.map(item => {
        let datastr = { 
          value: item.project_num, 
          name: item.institution 
        }
        dataArr.push(datastr)
      })
      console.log(dataArr)
      let option = {
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: "{b}: {c}({d}%)"
        },
        legend: {
          type: 'scroll',
          top: '5%',
          bottom: '8%',
          bottom: 'center',
          orient: 'horizontal'
        },
        colorBy: 'data',
        series: [{
          top: '30px',
          type: 'pie',
          radius: ['40%', '70%'],
          label: {
            show: false,
            formatter: "{b}: {c}",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 22,
              fontWeight: 'bold',
              formatter: '{b}: {c}'
            }
          },
          labelLine: {
            show: true
          },
          data: dataArr
        }]
      }
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      charts.setOption(option)
    })
  },
  methods: {
    handleChangepage (val) {
      this.loading = true
      this.ajax_data.page.startPage = val
      getStatProjectByInstitution(this.ajax_data).then(res => {
        this.loading = false
        this.allNum = res.count
        let newData = res.result
        newData.forEach((val, index) => {
          val.percentstr = (val.percent*100).toFixed(2)
        })
        this.sData = newData
      })
    },
    handleExpand(row, expandedRows) {
      // this.subloading = true
      console.log(row, expandedRows)
      this.expands = []
      if (expandedRows.length) {
        expandedRows.map((item, key) => {
          this.expands.push(item.project_id)
        })
        this.ajax_data_sublist.search.project_id = row.project_id
        this.ajax_data_sublist.page.startPage = 1
        getSearchSubProjectList(this.ajax_data_sublist).then(res => {
          // this.subloading = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          let subList = newData
          // console.log(subList)
          row.subtableData = subList
        })
      } else {
        this.expands = []
      }
    },
    handleSort (column, prop, order) {
      // console.log(column, prop, order)
      this.loading = true
      this.ajax_data.order.item = column.prop
      this.ajax_data.order.type = this.orderConvert[column.order]
      if (column.order !== null && column.prop !== null) {
        getStatProjectByInstitution(this.ajax_data).then(res => {
          this.loading = false
          this.allNum = res.count
          let newData = res.result
          newData.forEach((val, index) => {
            val.percentstr = (val.percent*100).toFixed(2)
          })
          this.sData = newData
        })
      } else {
        this.loading = false
      }
    },
    handleSearch() {
      this.loading = true
      this.ajax_data.search.sub = this.searchkey
      getStatProjectByInstitution(this.ajax_data).then(res => {
        this.loading = false
        this.allNum = res.count
        let newData = res.result
        newData.forEach((val, index) => {
          val.percentstr = (val.percent*100).toFixed(2)
        })
        this.sData = newData
      })
    },
    handleClickInst(val) {
      this.isShowpro = true
      this.ajax_data_pro.search.institution = val
      getStatProjectListByInstitution(this.ajax_data_pro).then(res => {
        this.loading2 = false
        this.allNum2 = res.count
        this.proData = res.result
      })
    },
    handleChangepage2 (val) {
      this.loading2 = true
      this.ajax_data_pro.page.startPage = val
      getStatProjectListByInstitution(this.ajax_data_pro).then(res => {
        this.loading2 = false
        this.allNum2 = res.count
        this.proData = res.result
      })
    },
    handleFilesize(param) {
      let fileSize = param;
      if (fileSize == 0 || fileSize == null) {
        fileSize = ' (' + 0 +'K)';
      } else if (fileSize < 1024) {
        fileSize = ' (' + fileSize.toFixed(2) + 'K)';
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize =  ' (' + (fileSize / 1024).toFixed(2)+ 'M)'
      } else {
        fileSize =   ' ('
          + (fileSize / 1024 / 1024).toFixed(2)
          + 'G)'
      }
      return fileSize
    },
    handleSort2 (column, prop, order) {
      // console.log(column, prop, order)
      this.loading2 = true
      this.ajax_data_pro.order.item = column.prop
      this.ajax_data_pro.order.type = this.orderConvert[column.order]
      if (column.order !== null && column.prop !== null) {
        getStatProjectListByInstitution(this.ajax_data_pro).then(res => {
          this.loading2 = false
          this.allNum2 = res.count
          this.proData = res.result
        })
      } else {
        this.loading2 = false
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
